import type { TRequestMethod } from '@common/http/definitions'

import baseAjax from '@common/ajax/promise/ajax'

import {
  EProductRoute, ECategoryRoute, EContactUsRoute, ENewsletterRoute
} from './definitions'

interface IParams {
  readonly data?: TAnyObject
  readonly method?: TRequestMethod
  readonly contentType?: string
}

interface IAjaxResponse {
  readonly isSuccess: boolean
  readonly result: TAnyObject
}

const STATUS_OK = 200

const ajax = {
  send: async (url: string, params: IParams = {}): Promise<IAjaxResponse> => {
    const response = await baseAjax(url, params)

    const isSuccess = response?.status === STATUS_OK

    const result = response?.responseText && response?.responseText.length > 0
      // oxlint-disable-next-line no-restricted-globals
      ? JSON.parse(response?.responseText ?? '{}')
      : {}

    return { isSuccess, result }
  },
  routes: {
    contactUs: EContactUsRoute,
    newsletter: ENewsletterRoute,
    product: EProductRoute,
    category: ECategoryRoute
  }
} as const

export default ajax
